<template>
  <div class="search-box">
    <div class="search-list">
      <div class="search-li" v-for="(item, index) in search" :key="index" @click="onClickRoute(item)">
        <div class="search-left">
          <div class="search-h">
            {{item.title}}
          </div>
          <div class="search-time">
            {{item.createTimeFormat}}
          </div>
        </div>
        <div class="search-right">
          <img :src="getImageUrl(item.categories)" alt="搜索图" />
        </div>
      </div>
    </div>
    <el-pagination v-if="search.length > 0" class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "search",
  props: {
    search: {
      type: Array,
      required: true // 父组件传递课程列表
    },
    page: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      appPage: {
        NEWS: 'NewsDetails', // 新闻资讯
        COURSE: 'CourseDetails', // 质控课程
        SCIENCE: 'NewsDetailsTwo', // 科普知识
        GUIDE_CONSENSUS: 'NewsDetailsThree', // 指南共识
        NOTICE: 'QualityControlDetails', // 质控公告
      },
      appImage: {
        NEWS: 'Search5', // 新闻资讯
        COURSE: 'Search4', // 质控课程
        SCIENCE: 'Search7', // 科普知识
        GUIDE_CONSENSUS: 'Search1', // 指南共识
        NOTICE: 'Search6', // 质控公告
      },
    }
  },
  methods: {
    getImageUrl(categories) {
      return require(`@/assets/images/${this.appImage[categories]}.png`);
    },
    onClickRoute(value) {
      this.$router.push({ path: `/${this.appPage[value.categories]}/${value.id}` });
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
};
</script>

<style scoped lang="less">
.search-list{
  .search-li{
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    display: flex;
    padding: 14px 10px;
    justify-content: space-between;
    cursor: pointer;
    .search-left{
      text-align: left;
      .search-h{
        color: #222222;
        font-size: 16px;
        line-height: 18px;
        height: 36px;
      }
      .search-time{
        color: #737373;
        font-size: 12px;
        line-height: 12px;
        margin-top: 18px;
      }
    }
    .search-right{
      img{
        width: 70px;
        display: block;
        border-radius: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/index.vue